<template>
	<div class="element-usersig element-signature form-group is-empty">
		<label class="element-label" :class="classes('title')"><span v-html="macro(label)"></span></label>
		<div class="signed input-group">
			<div class="form-control" :class="classes('input')">
				<img class="signature" :src="signature" />
			</div>
		</div>
		<small class="form-text" :class="classes('description')">
			<span>
				<span>{{$t('app.common.signed')}}</span> 
				<span v-html="macro('&nbsp;' + signer + '&nbsp;')"></span>
				<span>{{$t('app.common.on')}}</span>
				<span>&nbsp;{{signed}}&nbsp;</span>
			</span> &nbsp;
		</small>
	</div>
</template>

<script>
import store from '../../store'

export default {
	props: {
		definition: { type: Object, required: true },
		element:    { type: Object, required: true },
	},
	computed: {
		label()     { return this.options('label')  },
		signer()    { return this.options('signer') },
		type()      { return this.options('type').toLowerCase() },
		signature() { return this.options('signature') },
		signed()    { 
			return store.state.created ? 
				new Date(store.state.created.substring(0, 19).replace(" ","T") + 'Z').toUTCString() : new Date().toUTCString()
		}
	},
	methods: {
		classes(index) { return store.getters['classes'](index) + " " + this.type },
		macro  (value) { return store.getters['macro'](value) },
		options(value) { return store.getters['options'](this.definition, value) },
	}
}
</script>
